// authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {RootState} from "./ApiSlice";

interface AuthState {
  token: string | null
}

const initialState: AuthState = {
  token: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    clearToken: (state) => {
      state.token = null
    },
  },
})

export const { setToken, clearToken } = authSlice.actions
export const selectAuth = (state: RootState) => state.auth
export default authSlice.reducer
